(function () {
if (!customElements.get("nss-modal")) customElements.define("nss-modal", class NSSModal extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            trigger: ".js-nss-modal-trigger",
            closeButton: ".js-nss-modal-close",
            dialog: ".js-nss-modal-dialog"
        };
        this.dataModal = this.getAttribute("data-modal");
        this.closeButton = this.querySelector(this.selectors.closeButton);
        this.trigger = document.querySelector(`${this.selectors.trigger}[data-modal="${this.dataModal}"]`);
        this.dialog = this.querySelector(this.selectors.dialog);
        this.allButtons = this.querySelectorAll("a, button");
        this.firstFocusableElement = this.allButtons[0];
        this.lastFocusableElement = this.allButtons[this.allButtons.length - 1];
        this.endDate = this.getAttribute("data-end-date");
        const currentDate = new Date();
        const pstDate = new Date(currentDate.toLocaleString("en-US", {
            timeZone: "America/Los_Angeles"
        }));
        const targetDate = new Date(this.endDate);
        if (pstDate < targetDate || this.endDate == "") this.init();
        else this.remove();
    }
    openDialog() {
        this.classList.add("is-visible");
        this.closeButton?.focus();
    }
    closeDialog() {
        this.classList.remove("is-visible");
        this.trigger?.focus();
    }
    init() {
        // Open the dialog when the trigger button is activated.
        this.trigger?.addEventListener("click", (e)=>{
            this.openDialog();
        });
        // Close the dialog when the inner close button is activated.
        this.closeButton?.addEventListener("click", (e)=>{
            this.closeDialog();
        });
        // Close the dialog when the user clicks on the backdrop.
        this.addEventListener("click", (e)=>{
            if (!this.dialog.contains(e.target)) this.closeDialog();
        });
        // Close the dialog when 'Escape' key is pressed.
        this.addEventListener("keydown", (e)=>{
            if (e.key == "Escape") this.closeDialog();
        });
        // Trap keyboard focus by moving focus to the first or last focusable element when the user tries to tab (or "backwards" tab) past them.
        this.dialog.addEventListener("keydown", (e)=>{
            if (e.target == this.firstFocusableElement && e.key == "Tab" && e.shiftKey) {
                e.preventDefault();
                this.lastFocusableElement.focus();
            } else if (e.target == this.lastFocusableElement && e.key == "Tab" && !e.shiftKey) {
                e.preventDefault();
                this.firstFocusableElement.focus();
            }
        });
        document.addEventListener("shopify:section:select", (event)=>{
            if (this.closest(`#shopify-section-${event?.detail?.sectionId}`) != null) this.openDialog();
            else this.closeDialog();
        });
    }
});

})();
